(function () {
  function getMediaWrapper(card) {
    return card.querySelector('.watch-shop__media-wrapper[data-video-url]');
  }

  function mountPlaybackVideo(wrapper) {
    const url = wrapper.dataset.videoUrl;
    if (!url) return null;

    let video = wrapper.querySelector('video.watch-shop__playback-video');
    if (!video) {
      video = document.createElement('video');
      video.className = 'watch-shop__playback-video';
      video.playsInline = true;
      video.preload = 'auto';
      video.setAttribute('playsinline', '');
      wrapper.insertBefore(video, wrapper.querySelector('.watch-shop__overlay'));
    }

    if (!video.src || video.getAttribute('src') !== url) {
      video.src = url;
      video.load();
    }

    const poster = wrapper.querySelector('.watch-shop__poster');
    if (poster instanceof HTMLImageElement && poster.currentSrc) {
      video.poster = poster.currentSrc;
    } else if (wrapper.dataset.posterUrl) {
      video.poster = wrapper.dataset.posterUrl;
    }

    return video;
  }

  function teardownPlaybackVideo(video) {
    if (!video) return;

    video.pause();
    video.controls = false;
    video.muted = true;
    video.classList.remove('watch-shop__playback-video--active');
    video.removeAttribute('src');
    video.load();
    video.remove();
  }

  function initWatchShop(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-watch-shop]').forEach((section) => {
      if (section.dataset.watchShopBound === 'true') return;
      section.dataset.watchShopBound = 'true';

      const cards = section.querySelectorAll('.watch-shop__card');
      let activeVideo = null;
      let activeCard = null;

      const resetActive = () => {
        if (!activeVideo || !activeCard) return;
        teardownPlaybackVideo(activeVideo);
        activeCard.classList.remove('watch-shop__card--playing');
        activeVideo = null;
        activeCard = null;
      };

      cards.forEach((card) => {
        const wrapper = getMediaWrapper(card);
        if (!wrapper) return;

        const play = (event) => {
          if (event.target.closest('.watch-shop__cta-btn') || event.target.closest('a')) return;

          event.preventDefault();
          event.stopPropagation();

          if (card.classList.contains('watch-shop__card--playing')) {
            resetActive();
            return;
          }

          resetActive();

          const video = mountPlaybackVideo(wrapper);
          if (!video) return;

          card.classList.add('watch-shop__card--playing');
          video.classList.add('watch-shop__playback-video--active');
          video.muted = false;
          video.controls = true;

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }

          activeVideo = video;
          activeCard = card;
        };

        const playBtn = card.querySelector('.watch-shop__play-btn');
        if (playBtn) {
          playBtn.addEventListener('click', play);
        }

        wrapper.addEventListener('click', (event) => {
          if (event.target.closest('.watch-shop__play-btn')) return;
          if (!event.target.closest('.watch-shop__cta-btn') && !event.target.closest('a')) {
            play(event);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWatchShop(document));
  } else {
    initWatchShop(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWatchShop(event.target));
})();
